/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { intlShape, injectIntl } from 'react-intl';

import messages from 'src/shared/app/moderation/l10n/zmoderationL10n';
import Notification from 'src/shared/app/notification/component/Notification';

import type { Notification as NotificationType } from 'src/shared/app/notification/type/notificationTypes';

type Props = {
  notification: NotificationType,
  eventName: string,
  slackChannelName: string,
  handleDismiss: () => void,
  // Self passed
  // $FlowIssue
  intl: intlShape,
};

const ModerationAcceptedAndSlackNotificationDumb = (
  props: Props,
): React.Node => {
  const { eventName, slackChannelName, handleDismiss, intl } = props;

  // Elements

  return (
    <Notification timeout={10000} handleDismiss={handleDismiss}>
      {intl.formatMessage(messages.moderationAcceptedAndSlackNotification, {
        eventName,
        slackChannelName,
      })}
    </Notification>
  );
};

export default compose(injectIntl)(ModerationAcceptedAndSlackNotificationDumb);
